import type { RegistryEntry } from '../types';

// elevenlabs dubbing (via Wavespeed): video translation
export const elevenlabsConfigs: Record<string, RegistryEntry> = {
    'elevenlabs/dubbing': (() => {
        const langs = ['English', 'Spanish', 'French', 'German', 'Italian', 'Portuguese', 'Chinese', 'Japanese', 'Korean', 'Russian', 'Arabic', 'Hindi', 'Dutch', 'Polish', 'Turkish', 'Vietnamese', 'Thai', 'Indonesian'];
        return {
            options: [
                { key: 'target_lang', label: 'Target Language', type: 'select', options: langs.map(l => ({ label: l, value: l })), default: 'Chinese', group: 'basic' },
            ],
            toProviderOptions: (ui) => {
                const raw = typeof ui.target_lang === 'string' ? ui.target_lang.trim() : '';
                return { target_lang: langs.includes(raw) ? raw : 'Chinese' } as unknown as Record<string, Record<string, any>>;
            },
        } satisfies RegistryEntry;
    })(),
};
